export default {
      id: "comment-usage",
      viewBox: "0 0 29.732 27.354",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#comment",
      toString: function () {
        return this.url;
      }
    }